export function searchGroups(groups, query) {
  const terms = String(query || "").split(",")
    .map((term) => term.trim().toLocaleLowerCase())
    .filter(Boolean);
  if (terms.length === 0) return groups || [];
  return (groups || []).filter((group) => {
    const fields = [group.name, group.otherName, group.mgroupID, group.description]
      .map((field) => String(field || "").toLocaleLowerCase());
    return terms.some((term) => fields.some((field) => field.includes(term)));
  });
}
